import { render, staticRenderFns } from "./BaseMaterialDesignIconButton.vue?vue&type=template&id=51ae2980&scoped=true&"
import script from "./BaseMaterialDesignIconButton.vue?vue&type=script&lang=js&"
export * from "./BaseMaterialDesignIconButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ae2980",
  null
  
)

export default component.exports